import React from 'react';
import { motion } from 'framer-motion';
import { Ornament } from './Ornament';
export function Author() {
  return <section className="py-10 px-5 bg-navy-800/30" data-id="element-18">
      <div className="max-w-lg mx-auto" data-id="element-19">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-20">
          <p className="text-gold-400 text-xs tracking-[0.2em] uppercase mb-3" data-id="element-21">
            Sobre la autora
          </p>

          <h2 className="font-serif text-2xl text-cream-100 mb-4" data-id="element-22">
            Odalia Morán Arévalo
          </h2>

          <div className="space-y-3 text-[14px] leading-relaxed text-cream-300/90 font-light text-left" data-id="element-23">
            <p data-id="element-24">
              Odalia Morán Arévalo no escribió este devocional desde la
              comodidad de tener todo resuelto.
            </p>
            <p data-id="element-25">
              Lo escribió desde la experiencia de haber esperado, dudado, y
              seguido de todas formas.
            </p>
            <p data-id="element-26">
              Fundadora del movimiento Valor · Propósito · Fe, Odalia ha
              acompañado a cientos de mujeres a reconectar su fe con su
              propósito real. No con fórmulas. No con religiosidad. Con
              revelación y acción.
            </p>
            <p className="font-serif text-base text-gold-400 italic text-center py-3 border-y border-gold-500/10 my-3" data-id="element-27">
              "Fui Llamada Para Este Momento" es su llamado a cada mujer que
              siente que su historia todavía no tiene sentido.
            </p>
            <p className="text-center font-medium text-cream-100" data-id="element-28">
              Lo tendrá. Y está a 12 días de distancia.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}